import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ProblemReportService = sdk.getService('ProblemReportService');

export const usePendingOpenReportMessages = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['problem-reports', 'count', 'not-reviewed'],
    queryFn: () => ProblemReportService.getPendingOpenReportsMessages()
  });

  return {
    pendingReports: data ?? 0,
    isLoading,
    error
  };
};
